import { isDev } from "@src/utils/enviroment/isDev";
import { isLocal } from "@src/utils/enviroment/isLocal";
import { useState } from "react";
import { When } from "../When";
import { DevToolsHalfView } from "./DevToolsHalfView";
import { DraggableDevButton } from "./DraggableDevButton";

export const DevTools = () => {
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  const handleDevToolsHalfViewClose = () => {
    setIsDevToolsOpen(false);
  };

  const handleOpenDevToolsHalfView = () => {
    setIsDevToolsOpen(true);
  };

  return (
    <When if={isDev() || isLocal()}>
      <DraggableDevButton onClick={handleOpenDevToolsHalfView} />
      <DevToolsHalfView
        isDevToolsOpen={isDevToolsOpen}
        onClose={handleDevToolsHalfViewClose}
      />
    </When>
  );
};
